import { redirect } from "react-router-dom"
import { authStore } from "./login/auth-store"
import { PUBLIC_PATHS } from "@/constants/public-path"
import { langStore } from "@/stores/lang-store"
import { toast } from "sonner"

export const protectedLoader = async ({ request, params }) => {
  const pathname = new URL(request.url).pathname
  const { region, aptCode } = params

  langStore.getState().syncIfNotUserSelected()

  const store = authStore.getState()

  if (!store.isAuthenticated) {
    const user = await store.accessUserCheck()

    if (!user) {
      throw redirect("/")
    }
  }

  const { isAuthenticated, sido_key, scope_type, scope_code, scope_codes, role } =
    authStore.getState()

  if (!isAuthenticated) {
    throw redirect("/")
  }

  if (PUBLIC_PATHS.includes(pathname)) {
    return null
  }

  const sidoLowerCase = sido_key?.toLocaleLowerCase()

  const userPath = `/apt/${sidoLowerCase}/${scope_code}/overview`
  const selectAptPath = "/select/apt"

  if (role === "USER") {
    if (scope_type === "only") {
      if (!region || !aptCode) {
        toast.error("접근 권한이 없습니다.")
        throw redirect(userPath)
      }

      if (region !== sidoLowerCase || aptCode !== scope_code) {
        toast.error("접근 권한이 없습니다.")
        throw redirect(userPath)
      }
    }

    if (scope_type === "group") {
      if (!region || !aptCode) {
        if (pathname === selectAptPath) return null

        toast.error("접근 권한이 없습니다.")
        throw redirect(selectAptPath)
      }

      if (!scope_codes.includes(aptCode)) {
        toast.error("접근 권한이 없습니다.")
        throw redirect(selectAptPath)
      }
    }
  }

  return null
}
